import { isEmbedRoute } from "ls/composables/useIsEmbed";
import { useRouter } from "vue-router";
import { reloadAppAtPath } from "@/router/utils";

export function useEmbedGuard() {
  const router = useRouter();

  // register guard after initial navigation
  router.isReady().then(() => {
    router.beforeEach((to, from) => {
      // ignore initial navigation
      if (from.path === "/") {
        return true;
      }

      const isEmbedFrom = isEmbedRoute(from);
      const isEmbedTo = isEmbedRoute(to);

      const shouldReload = isEmbedFrom !== isEmbedTo;
      if (shouldReload) {
        reloadAppAtPath(to);
        return false;
      }

      return true;
    });
  });
}
